"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Storage = (function () {
    function Storage() {
        this._storage = {};
    }
    Storage.prototype.put = function (key, value) {
        this._storage[key] = value;
    };
    Storage.prototype.get = function (key) {
        return this._storage[key];
    };
    return Storage;
}());
var StorageFactory = (function () {
    function StorageFactory() {
    }
    StorageFactory.getStorage = function (key) {
        if (!StorageFactory.storages[key]) {
            StorageFactory.storages[key] = new Storage();
        }
        return StorageFactory.storages[key];
    };
    StorageFactory.storages = {};
    return StorageFactory;
}());
exports.StorageFactory = StorageFactory;
//# sourceMappingURL=Storage.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/Storage.js
// module id = 35
// module chunks = 0